import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Grid,
  FormControl,
  MenuItem,
  useMediaQuery,
  Dialog,
  IconButton,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { baseUrl, postData } from "../../BaseUrl";
import AnimationSlideRight from "../../Animation/AnimationSlideRight";
import AnimationSlideTop from "../../Animation/AnimationSlideTop";
import Slide from "@mui/material/Slide";
import CloseIcon from "@mui/icons-material/Close";
import colors from "../../Assest/Theme/Color";
import useTranslations from "../Translations/useTranslations";
import Toast from '../../DynamicComponent/Toast'
// AIzaSyAbjDBiTEtZk7aA2M-L-ErDEDfUUktIVEM

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ContactUsPage = () => {
  const isMobile = useMediaQuery("(max-width:768px)");

  const { translations } = useTranslations();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [open, setOpen] = useState(false);
  const [message] = useState("");
  const [toast, setToast] = useState({ open: false, severity: 'success', message: '' });

  const styles = {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: isMobile ? 0 : "20px",
      overflow: "hidden",
    },
    imageSection: {
      display: "flex",
      justifyContent: "center",
    },
    formSection: {
      padding: "2rem",
    },
    heading: {
      fontSize: "32px",
      fontFamily: "Caveat, serif",
      fontWeight: "normal",
      color: colors.secondary,
      marginBottom: "10px",
    },
    subheading: {
      fontSize: "18px",
      color: colors.black,
    },
    inputField: {
      backgroundColor: colors.white,
      borderRadius: "10px",
    },
    button: {
      backgroundColor: colors.primary,
      color: colors.white,
      fontSize: "16px",
      textTransform: "none",
      padding: "8px 30px",
      borderRadius: "10px",
    },
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = translations.nameRequired;
    if (!formData.email.trim() || !/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = translations.emailRequired;
    if (!formData.phone.trim() || !/^\d+$/.test(formData.phone))
      newErrors.phone = translations.phoneRequired;
    if (!formData.subject.trim())
      newErrors.subject = translations.subjectRequired;
    if (!formData.message.trim())
      newErrors.message = translations.messageRequired;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

    if (errors[name]) {
      let fieldError = "";
      if (name === "name" && !value.trim())
        fieldError = translations.nameRequired;
      if (name === "email" && (!value.trim() || !/\S+@\S+\.\S+/.test(value)))
        fieldError = translations.emailRequired;
      if (name === "phone" && (!value.trim() || !/^\d+$/.test(value)))
        fieldError = translations.phoneRequired;
      if (name === "subject" && !value.trim())
        fieldError = translations.subjectRequired;
      if (name === "message" && !value.trim())
        fieldError = translations.messageRequired;

      setErrors({ ...errors, [name]: fieldError });
    }
  };

  const handleSubmit = async (e) => {
    if (validateForm()) {
      try {
        let data = {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          subject: formData.subject,
          message: formData.message,
        };
        const response = await postData(`${baseUrl}contact-us`, data);
        // console.log("response",response.message )
        setToast({ open: true, severity: 'success', message: response.message });
        setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
        setTimeout(() => {
         reset();
       }, 1000);
      } catch (err) {
        setToast({ open: true, severity: 'error', message:'Something went wrong please try again later!' });
        console.error("Error:", err.message);
      }
    }
  };

  const reset=()=>
  {
      setErrors({});
      setToast({ open: false, severity: 'success', message: ''});
  }

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseToast=()=>
  {
    setToast({ open: false, severity: 'success', message: ''});
  }


  
  return (
    <div style={{ paddingTop: isMobile ? "4rem" : "6rem" }}>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        sx={{ p: 4 }}
        PaperProps={{
          style: {
            borderRadius: 15,
            background: message
              ? "linear-gradient(180deg, #FFFFFF, #FF9D9E)"
              : "linear-gradient(180deg, #FFFFFF, #88FF9E)",
            minWidth: 400,
            position: "relative",
            padding: "0 5px 25px 5px",
          },
        }}
      >
        <div style={{ position: "relative", width: "450px" }}>
          <IconButton
            sx={{
              position: "absolute", // Position it relative to the parent div
              top: 8, // Adjust the distance from the top
              right: 8, // Adjust the distance from the right
            }}
            onClick={handleClose} // Add the click handler if needed
          >
            <CloseIcon />
          </IconButton>
          <DialogTitle sx={{ textAlign: "center" }}>
            {/* <img src={verify} alt="verify" />{" "} */}
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              sx={{ textAlign: "center" }}
              id="alert-dialog-slide-description"
            >
              <p
                style={{ fontWeight: "bold", color: "#000", fontSize: "20px" }}
              >
                {message ? "Error" : "Thanks!"}
              </p>
              <p style={{ color: "#000", fontSize: "17px" }}>
                {message ? message : translations.yourResponseSubmitted}
              </p>
            </DialogContentText>
          </DialogContent>
        </div>
      </Dialog>
      
      <Box sx={styles.container}>
       
        <Grid
          container
          spacing={4}
          alignItems="center"
          width={isMobile ? "100%" : "60%"}
        >
          <Grid item xs={12} sm={12}>
              <div>
              <Toast open={toast.open} handleClose={handleCloseToast} severity={toast.severity} message={toast.message} /></div>
            <AnimationSlideTop duration={1.4} rootMargin={"-10px"}>
              <Box sx={styles.formSection}>
                {/* <form > */}
                <AnimationSlideRight duration={1.2} rootMargin={"-10px"}>
                  <Typography sx={styles.heading}>
                    {translations.contact_heading}
                  </Typography>
                </AnimationSlideRight>
                <AnimationSlideRight duration={1.3} rootMargin={"-10px"}>
                  <Typography sx={styles.subheading}>
                    {translations.thankYouMessage}
                  </Typography>
                </AnimationSlideRight>
                <Box sx={{ py: 2 }}>
                  <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    spacing={1}
                  >
                    <Grid item>
                      <Typography variant="body2" sx={{ color: "grey.600" }}>
                        Please use this form to
                      </Typography>
                    </Grid>

                    <Grid item>
                      <Typography variant="body2" sx={{ color: "grey.600" }}>
                        • Send Inquiries
                      </Typography>
                    </Grid>

                    <Grid item>
                      <Typography variant="body2" sx={{ color: "grey.600" }}>
                        • Share Feedback
                      </Typography>
                    </Grid>

                    <Grid item>
                      <Typography variant="body2" sx={{ color: "grey.600" }}>
                        • Raise Complaints
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Grid container spacing={2} mt={4}>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <TextField
                        name="name"
                        placeholder={translations.name_placeholder}
                        variant="outlined"
                        // fullWidth
                        value={formData.name}
                        onChange={handleInputChange}
                        error={!!errors.name}
                        helperText={errors.name}
                        InputProps={{ style: styles.inputField }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <TextField
                        name="email"
                        placeholder={translations.email_placeholder}
                        variant="outlined"
                        // fullWidth
                        value={formData.email}
                        onChange={handleInputChange}
                        error={!!errors.email}
                        helperText={errors.email}
                        InputProps={{ style: styles.inputField }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <TextField
                        name="phone"
                        placeholder={translations.phone_placeholder}
                        variant="outlined"
                        // fullWidth
                        value={formData.phone}
                        onChange={handleInputChange}
                        error={!!errors.phone}
                        helperText={errors.phone}
                        InputProps={{ style: styles.inputField }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <TextField
                        name="subject"
                        placeholder={translations.subject_placeholder}
                        variant="outlined"
                        // fullWidth
                        value={formData.subject}
                        onChange={handleInputChange}
                        error={!!errors.subject}
                        helperText={errors.subject}
                        InputProps={{ style: styles.inputField }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        name="message"
                        placeholder={translations.message_placeholder}
                        variant="outlined"
                        multiline
                        rows={4}
                        value={formData.message}
                        onChange={handleInputChange}
                        error={!!errors.message}
                        helperText={errors.message}
                        inputProps={{
                          maxLength: 800, 
                        }}
                        InputProps={{
                          style: styles.inputField,
                        }}
                        style={{ marginBottom: "10px" }}
                      />
                      <span style={{ textAlign: "left", fontSize: "12px" , marginBottom:'10px'}}>
                        Note: Message max 800 characters
                      </span>
                    </FormControl>
                  </Grid>
                </Grid>
                <div>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={styles.button}
                    onClick={handleSubmit}
                  >
                    {translations.submit_button}
                  </Button>
                </div>
                {/* </form> */}
              </Box>
            </AnimationSlideTop>
          </Grid>
        </Grid>
      </Box>

      {/* ── Feedback Section (§2.2.2) ── */}
      <Box sx={{ maxWidth: "60%", mx: "auto", mt: 4, mb: 4 }}>
        <FeedbackForm />
      </Box>

      {/* <Grid container spacing={2} mt={2}>
        <Grid item xs={12} sm={4}>
          <AnimationSlideTop duration={1} rootMargin={"-10px"}>
            <div style={{ position: "relative" }}>
              <img src={img1} alt="img3" />
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-48%, -30%)",
                  textAlign: "center",
                }}
              >
                <p style={{ color: colors.subText }}>
                  {translations.haveAnyQuestion}
                </p>
                <p style={{ fontWeight: "bold" }}>Free + 23 (000)-8050</p>
              </div>
            </div>
          </AnimationSlideTop>
        </Grid>
        <Grid item xs={12} sm={4} mt={isMobile ? 2 : 0}>
          <AnimationSlideTop duration={1} rootMargin={"-10px"}>
            <div style={{ position: "relative" }}>
              <img src={img2} alt="img3" />
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-43%, -80%)",
                  textAlign: "center",
                  wordWrap: "break-word", // Make sure long text wraps within the div
                }}
              >
                <p style={{ color: colors.subText }}>
                  {translations.sendEmail}
                </p>
                <p
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    wordBreak: "break-word",
                    width: "90%",
                  }}
                >
                  Contact@cummingtamilschool.org
                </p>
              </div>
            </div>
          </AnimationSlideTop>
        </Grid>
        <Grid item xs={12} sm={4} mt={isMobile ? 2 : 0}>
          <AnimationSlideTop duration={1} rootMargin={"-10px"}>
            <div style={{ position: "relative" }}>
              <img src={img3} alt="img3" />
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-48%, -25%)",
                  textAlign: "center",
                }}
              >
                <p style={{ color: colors.subText }}>
                  {translations.visitAnytime}
                </p>
                <p
                  style={{ fontWeight: "600", fontSize: "13px", lineHeight: 1 }}
                >
                  <LocationOn fontSize="small" />
                  Big Creek Elementary School,
                </p>
                <p
                  style={{
                    fontWeight: "600",
                    fontSize: "13px",
                    lineHeight: 1,
                    marginBottom: "-4px",
                  }}
                >
                  1994 Peachtree Pkwy,
                </p>
                <p
                  style={{
                    fontWeight: "600",
                    fontSize: "13px",
                    lineHeight: 1,
                    marginBottom: "-4px",
                  }}
                >
                  Cumming, GA 30041
                </p>
              </div>
            </div>
          </AnimationSlideTop>
        </Grid>
      </Grid> */}
      <Grid container my={8}>
        <Grid xs={12}>
          {/* <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d5042.779795941477!2d-1.0853113568410266!3d50.80541441682165!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1737459298183!5m2!1sen!2sin"
            width="95%"
            height="450"
            style={{ border: 0, borderRadius: "50px" }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            title="map"
          ></iframe> */}

          {/* map component  */}
          {/* <div style={{width:'90%', margin:'auto'}}>
          <MapView />
          </div> */}
          {/* map component  */}
          
        </Grid>
      </Grid>
    </div>
  );
};

// ── Feedback Form Component (§2.2.2) ─────────────────────

const FeedbackForm = () => {
  const [feedback, setFeedback] = useState({ name: "", email: "", rating: "5", category: "General", message: "" });
  const [toast, setToast] = useState({ open: false, severity: "success", message: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!feedback.name || !feedback.email || !feedback.message) {
      setToast({ open: true, severity: "error", message: "Please fill in name, email and message." });
      return;
    }
    setLoading(true);
    try {
      await postData("contact-us/feedback", feedback);
      setToast({ open: true, severity: "success", message: "Thank you for your feedback!" });
      setFeedback({ name: "", email: "", rating: "5", category: "General", message: "" });
    } catch (_) {
      setToast({ open: true, severity: "error", message: "Failed to submit. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      backgroundColor: "#F9FAFB", borderRadius: "16px",
      border: "1px solid #E5E7EB", p: 3
    }}>
      <Toast open={toast.open} handleClose={() => setToast({ ...toast, open: false })}
        severity={toast.severity} message={toast.message} />
      <Typography sx={{ fontWeight: 700, fontSize: "20px", color: "#111827", mb: 0.5 }}>
        Share Your Feedback
      </Typography>
      <Typography sx={{ fontSize: "13px", color: "#6B7280", mb: 2.5 }}>
        Help us improve by sharing your experience
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth size="small" placeholder="Your Name" value={feedback.name}
            onChange={e => setFeedback(p => ({ ...p, name: e.target.value }))}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px", backgroundColor: "#fff" } }} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth size="small" placeholder="Email Address" type="email" value={feedback.email}
            onChange={e => setFeedback(p => ({ ...p, email: e.target.value }))}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px", backgroundColor: "#fff" } }} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth size="small" select label="Category" value={feedback.category}
            onChange={e => setFeedback(p => ({ ...p, category: e.target.value }))}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px", backgroundColor: "#fff" } }}>
            {["General", "Teaching Quality", "Administration", "Facilities", "Communication", "Other"].map(o => (
              <MenuItem key={o} value={o}>{o}</MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth size="small" select label="Rating (out of 5)" value={feedback.rating}
            onChange={e => setFeedback(p => ({ ...p, rating: e.target.value }))}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px", backgroundColor: "#fff" } }}>
            {["1", "2", "3", "4", "5"].map(r => (
              <MenuItem key={r} value={r}>{"★".repeat(Number(r))} ({r}/5)</MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth size="small" multiline rows={3} placeholder="Your feedback..." value={feedback.message}
            onChange={e => setFeedback(p => ({ ...p, message: e.target.value }))}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px", backgroundColor: "#fff" } }} />
        </Grid>
        <Grid item xs={12} sx={{ textAlign: "right" }}>
          <Button onClick={handleSubmit} disabled={loading} variant="contained"
            sx={{
              backgroundColor: "#2D3A5C", color: "#fff", borderRadius: "10px",
              textTransform: "none", fontSize: "14px", px: 4,
              "&:hover": { backgroundColor: "#1e2a45" }
            }}>
            {loading ? "Submitting..." : "Submit Feedback"}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContactUsPage;
